import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchOffer } from '../../../../common/api/clients/order.api';
import { queries } from '../../../../common/api/queryKeys/queries';
import { OfferState } from '../../../model/OfferState';

interface ReopenOfferParams {
    offerId: string;
    requestForQuoteId?: string;
}

export const useOfferReopen = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ offerId }: ReopenOfferParams) =>
            patchOffer({
                offerId,
                offer: {
                    state: OfferState.ENQUIRY,
                },
            }),
        onSuccess: (data, variables) => {
            const requestForQuoteId = data.requestForQuoteId ?? variables.requestForQuoteId;
            const invalidations = [
                queryClient.invalidateQueries({ queryKey: queries.offers.detail(data.id).queryKey }),
                queryClient.invalidateQueries({ queryKey: queries.orders.detail(data.orderId).queryKey }),
            ];

            if (requestForQuoteId) {
                invalidations.push(
                    queryClient.invalidateQueries({
                        queryKey: queries.requestsForQuotes.detail(requestForQuoteId).queryKey,
                    })
                );
            }

            invalidations.push(
                queryClient.invalidateQueries({
                    queryKey: queries.offers.list({ orderIds: [data.orderId] }).queryKey,
                })
            );

            return Promise.all(invalidations);
        },
    });
};
